(() => {
  // Draft-only fork of ola-3d-sizing-tool-28 (df548061...). Shared deployment unchanged.
  if (customElements.get('ola-product-addons')) return;
  const countDiagnostics=document.currentScript?.dataset.olaBatchDiagnostics==='counts';
  const allowed = new Set(['P','BR','STRONG','B','EM','I','U','S','UL','OL','LI','H2','H3','H4','H5','H6','BLOCKQUOTE','DIV','SPAN','TABLE','THEAD','TBODY','TR','TH','TD','A','IMG','HR']);
  const discard = new Set(['SCRIPT','STYLE','IFRAME','OBJECT','EMBED','FORM','INPUT','BUTTON','SVG','MATH','LINK','META']);
  function safeUrl(value) {
    try { const url=new URL(value,location.origin); return ['https:','http:'].includes(url.protocol) ? url.href : ''; } catch {return '';}
  }
  function clean(source) {
    const result=document.createDocumentFragment();
    for (const node of source.childNodes) {
      if(node.nodeType===Node.TEXT_NODE) {result.append(document.createTextNode(node.textContent));continue;}
      if(node.nodeType!==Node.ELEMENT_NODE || discard.has(node.tagName)) continue;
      if(!allowed.has(node.tagName)) {result.append(clean(node));continue;}
      const element=document.createElement(node.tagName.toLowerCase());
      if(node.tagName==='A') {const href=safeUrl(node.getAttribute('href'));if(href) {element.href=href;element.target='_blank';element.rel='noopener noreferrer';}}
      if(node.tagName==='IMG') {const src=safeUrl(node.getAttribute('src'));if(!src) continue;element.src=src;element.alt=node.getAttribute('alt') || '';element.loading='lazy';}
      element.append(clean(node));result.append(element);
    }
    return result;
  }
  const widgets=new Set();
  let cart=null, queue=Promise.resolve(), initialRefresh=null, scheduledRefresh=null;
  // Coalesce notification bursts; mutation verification always performs its own fresh read.
  function scheduleRefresh(widget) {
    if(!scheduledRefresh) scheduledRefresh=enqueue(()=>{scheduledRefresh=null;return refreshCart(widget);});
    return scheduledRefresh;
  }
  const enqueue=task=>{const result=queue.then(task);queue=result.catch(()=>{});return result;};
  async function request(url, body) {
    const abort=new AbortController(), timer=setTimeout(()=>abort.abort(),20000);
    try {
      const response=await fetch(url,{method:body?'POST':'GET',credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json',...(body?{'Content-Type':'application/json'}:{})},...(body?{body:JSON.stringify(body)}:{}),signal:abort.signal});
      const data=await response.json();
      if(!response.ok) throw new Error(typeof data.description==='string'?data.description:'Cart request failed.');
      return data;
    } finally {clearTimeout(timer);}
  }
  function applyCart(next) {
    if(!Array.isArray(next.items) || !Number.isInteger(next.item_count)) throw new Error('Invalid cart response.');
    cart=next;
    // Superstore displays this attribute with CSS; its popup events are not needed.
    document.querySelectorAll('[data-header-cart-count]').forEach(el=>{
      el.setAttribute('data-header-cart-count',String(cart.item_count));el.classList.toggle('visible',cart.item_count>0);
      el.closest('.site-header-cart-button')?.classList.toggle('count-hidden',cart.item_count===0);
    });
    widgets.forEach(widget=>widget.querySelectorAll('.oa-card').forEach(card=>widget.updateButton(card)));
  }
  async function readCart(widget) {
    const next=await request(`${widget.dataset.cartUrl}.js`);
    if(!Array.isArray(next.items) || !Number.isInteger(next.item_count) || next.items.some(item=>!Number.isInteger(item.quantity) || item.quantity<0) || next.items.reduce((sum,item)=>sum+item.quantity,0)!==next.item_count) throw new Error('Invalid cart response.');
    return next;
  }
  async function refreshCart(widget) {const next=await readCart(widget);applyCart(next);return next;}
  function matchingLines(widget,variant,state=cart) {return state?.items.filter(item=>String(item.variant_id)===String(variant) && item.properties?._ola_addon===`${widget.dataset.offer}:${widget.dataset.product}`) || [];}
  function matchingQuantity(widget,variant,state) {return matchingLines(widget,variant,state).reduce((sum,item)=>sum+item.quantity,0);}
  function matchingLine(widget,variant) {return matchingLines(widget,variant)[0];}
  class ProductAddons extends HTMLElement {
    async addBatch(cards) {
      this.updateEligibility();
      const uniqueCards=[...new Set(cards)];
      const intents=uniqueCards.map(card=>({card,variant:card.querySelector('[name="id"]').value}));
      if(!intents.length || intents.some(({card})=>!this.contains(card) || card.dataset.available!=='true') || this.dataset.eligible==='false') {
        this.querySelector('.oa-status').textContent=this.dataset.cartError;
        return {ok:false};
      }
      intents.forEach(({card})=>{card.dataset.pending='true';this.updateButton(card);});
      this.querySelector('.oa-status').textContent='';
      try {
        await enqueue(async()=>{
          const beforeCart=await readCart(this);
          // Capture variant intent once; revalidate before the one mutation.
          this.updateEligibility();
          if(this.dataset.eligible==='false' || intents.some(({card,variant})=>card.querySelector('[name="id"]').value!==variant || card.dataset.available!=='true')) throw new Error(this.dataset.cartError);
          const variants=[...new Set(intents.map(intent=>intent.variant))];
          const expected=new Map(variants.map(variant=>[variant,matchingQuantity(this,variant,beforeCart) || 1]));
          const items=variants.filter(variant=>!matchingQuantity(this,variant,beforeCart)).map(id=>({id,quantity:1,properties:{_ola_addon:`${this.dataset.offer}:${this.dataset.product}`}}));
          if(items.length) {
            // Draft-only, opt-in counts: requested payload size, not network timing/success.
            if(countDiagnostics) {
              this.dataset.olaBatchRequests=String(Number(this.dataset.olaBatchRequests || 0)+1);
              this.dataset.olaLastBatchSize=String(items.length);
              this.dataset.olaBatchSizes=[...(this.dataset.olaBatchSizes || '').split(',').filter(Boolean).slice(-7),String(items.length)].join(',');
            }
            await request(`${this.dataset.cartUrl}/add.js`,{items});
          }
          const next=await readCart(this);
          if(variants.some(variant=>matchingQuantity(this,variant,next)!==expected.get(variant))) throw new Error(this.dataset.cartError);
          applyCart(next);
        });
        this.querySelector('.oa-status').textContent='';
        return {ok:true};
      } catch {
        // A failed batch may have partly succeeded: reconcile, never replay POST.
        await enqueue(()=>refreshCart(this)).catch(()=>{});
        this.querySelector('.oa-status').textContent=this.dataset.cartError;
        return {ok:false};
      } finally {intents.forEach(({card})=>{card.dataset.pending='false';this.updateButton(card);});}
    }
    connectedCallback() {
      if(this.abort) return;
      this.abort=new AbortController();const signal=this.abort.signal;
      this.track=this.querySelector('.oa-track');this.dialog=this.querySelector('dialog');widgets.add(this);
      this.querySelectorAll('.oa-card').forEach(card=>{
        const id=card.querySelector('[name="id"]').value;
        const option=[...card.querySelectorAll('[data-variant]')].find(v=>v.dataset.variant===id);
        if(option) card.querySelector('[data-variant-label]').textContent=option.textContent;
        this.updateButton(card);
      });
      if(!initialRefresh) initialRefresh=scheduleRefresh(this).catch(()=>{initialRefresh=null;});
      if(cart) this.querySelectorAll('.oa-card').forEach(card=>this.updateButton(card));
      this.addEventListener('click',event=>this.click(event),{signal});
      this.addEventListener('keydown',event=>{
        if(event.key==='Escape') this.querySelectorAll('details[open]').forEach(d=>{d.open=false;d.querySelector('summary').focus();});
        if(event.target===this.track && ['ArrowLeft','ArrowRight'].includes(event.key)) {event.preventDefault();this.scroll(event.key==='ArrowLeft'?-1:1);}
      },{signal});
      this.addEventListener('submit',event=>{
        if(!event.target.matches('[data-addon-cart]')) return;
        event.preventDefault();event.stopImmediatePropagation();
        this.toggleCart(event.target.closest('.oa-card'));
      },{capture:true,signal});
      document.addEventListener('pointerdown',event=>this.querySelectorAll('details[open]').forEach(d=>{if(!d.contains(event.target)) d.open=false;}),{signal});
      const schedule=()=>{cancelAnimationFrame(this.frame);this.frame=requestAnimationFrame(()=>{this.frame=requestAnimationFrame(()=>this.updateEligibility());});};
      document.addEventListener('change',schedule,{signal});
      document.addEventListener('variant:change',schedule,{signal});
      window.addEventListener('popstate',schedule,{signal});
      const refresh=()=>scheduleRefresh(this).catch(()=>{});
      window.addEventListener('pageshow',event=>{if(event.persisted) refresh();},{signal});window.addEventListener('focus',refresh,{signal});
      document.addEventListener('cart:updated',refresh,{signal});
      this.counterObserver=new MutationObserver(()=>{
        const counter=document.querySelector('[data-header-cart-count]');
        if(counter && cart && Number(counter.getAttribute('data-header-cart-count'))!==cart.item_count) refresh();
      });
      document.querySelectorAll('[data-header-cart-count]').forEach(el=>this.counterObserver.observe(el,{attributes:true,attributeFilter:['data-header-cart-count']}));
      this.dialog.addEventListener('close',()=>{document.body.style.overflow=this.oldOverflow ?? '';this.opener?.focus({preventScroll:true});},{signal});
      this.track.addEventListener('scroll',()=>this.edges(),{passive:true,signal});
      this.resize=new ResizeObserver(()=>this.edges());this.resize.observe(this.track);this.edges();
    }
    disconnectedCallback() {widgets.delete(this);this.counterObserver?.disconnect();this.abort?.abort();this.abort=null;this.resize?.disconnect();cancelAnimationFrame(this.frame);if(this.dialog?.open) {this.dialog.close();document.body.style.overflow=this.oldOverflow ?? '';}}
    updateEligibility() {
      const section=document.getElementById(`shopify-section-${this.dataset.section}`);
      const form=[...(section?.querySelectorAll('form[action*="/cart/add"]') || [])].find(f=>!f.matches('.oa-cart'));
      const id=form?.querySelector('[name="id"]')?.value;
      if(!id) return;
      const eligible=this.dataset.mainVariants.split(',').includes(String(id));
      this.dataset.eligible=String(eligible);this.querySelector('.oa-ineligible').hidden=eligible;
      this.querySelectorAll('.oa-card').forEach(c=>this.updateButton(c));
    }
    updateButton(card) {
      const button=card.querySelector('.oa-cart button'), available=card.dataset.available==='true', pending=card.dataset.pending==='true';
      const line=matchingLine(this,card.querySelector('[name="id"]').value);
      button.disabled=pending || (!line && (!available || this.dataset.eligible==='false'));
      button.setAttribute('aria-busy',String(pending));button.dataset.action=line?'remove':'add';
      button.textContent=line?button.dataset.remove:available?button.dataset.label:button.dataset.soldOut;
      card.querySelectorAll('[data-variant]').forEach(option=>{option.disabled=pending;});
      const summary=card.querySelector('summary');if(summary) summary.setAttribute('aria-disabled',String(pending));
    }
    async toggleCart(card) {
      if(card.dataset.pending==='true') return;
      this.updateEligibility();
      const button=card.querySelector('.oa-cart button');if(button.disabled) return;
      const variant=card.querySelector('[name="id"]').value, intent=button.dataset.action || 'add';
      card.dataset.pending='true';this.updateButton(card);this.querySelector('.oa-status').textContent='';
      try {
        await enqueue(async()=>{
          const beforeCart=await readCart(this);
          const lines=matchingLines(this,variant,beforeCart), before=matchingQuantity(this,variant,beforeCart);
          let expected=before;
          if(intent==='remove' && lines.length) {
            const line=lines[0];
            // Omit properties entirely: preserve Bespoke and all other existing metadata.
            await request(`${this.dataset.cartUrl}/change.js`,{id:line.key,quantity:line.quantity-1});
            expected=before-1;
          } else if(intent==='add' && !before) {
            await request(`${this.dataset.cartUrl}/add.js`,{items:[{id:variant,quantity:1,properties:{_ola_addon:`${this.dataset.offer}:${this.dataset.product}`}}]});
            expected=1;
          }
          const next=await readCart(this);
          if(matchingQuantity(this,variant,next)!==expected) throw new Error(this.dataset.cartError);
          // Confirm Shopify quantities before publishing a count. This does not signal Bespoke completion.
          applyCart(next);
        });
        this.querySelector('.oa-status').textContent='';
      } catch(error) {
        // Never blindly retry a POST: it may have succeeded before a connection failed.
        await enqueue(()=>refreshCart(this)).catch(()=>{});
        this.querySelector('.oa-status').textContent=this.dataset.cartError;
      } finally {card.dataset.pending='false';this.updateButton(card);}
    }
    galleryEdges() {
      const gallery=this.dialog.querySelector('.oa-gallery');if(!gallery) return;
      const prev=this.dialog.querySelector('[data-gallery-dir="-1"]'),next=this.dialog.querySelector('[data-gallery-dir="1"]');
      if(prev) prev.disabled=gallery.scrollLeft<2;
      if(next) next.disabled=gallery.scrollLeft+gallery.clientWidth>=gallery.scrollWidth-2;
    }
    edges() {this.querySelector('[data-scroll="-1"]').disabled=this.track.scrollLeft<2;this.querySelector('[data-scroll="1"]').disabled=this.track.scrollLeft+this.track.clientWidth>=this.track.scrollWidth-2;}
    scroll(direction) {this.track.scrollBy({left:direction*(this.track.firstElementChild.getBoundingClientRect().width+10),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});}
    click(event) {
      if(event.target.closest('.oa-cart button')) {event.stopPropagation();return;}
      const summary=event.target.closest('summary');if(summary?.closest('[data-pending="true"]')) {event.preventDefault();return;}
      const galleryArrow=event.target.closest('[data-gallery-dir]');
      if(galleryArrow) {
        const gallery=this.dialog.querySelector('.oa-gallery');
        gallery.scrollBy({left:Number(galleryArrow.dataset.galleryDir)*(gallery.clientWidth+12),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});return;
      }
      const arrow=event.target.closest('[data-scroll]');if(arrow) {this.scroll(Number(arrow.dataset.scroll));return;}
      const variant=event.target.closest('[data-variant]');
      if(variant) {
        const card=variant.closest('.oa-card');if(card.dataset.pending==='true') return;card.querySelector('[name="id"]').value=variant.dataset.variant;
        card.dataset.available=variant.dataset.available;const price=card.querySelector('.oa-price');
        if(price.querySelector('[data-original-price]')){price.querySelector('[data-original-price]').textContent=variant.dataset.price;price.querySelector('[data-sale-price]').textContent=variant.dataset.salePrice;}else{price.textContent=variant.dataset.price;}
        card.querySelector('[data-variant-label]').textContent=variant.textContent;
        card.querySelectorAll('[data-variant]').forEach(b=>b.setAttribute('aria-pressed',String(b===variant)));
        const img=card.querySelector('.oa-image img');if(img && variant.dataset.image) {img.removeAttribute('srcset');img.src=variant.dataset.image;}
        card.querySelector('details').open=false;card.querySelector('summary').focus();this.updateButton(card);return;
      }
      if(event.target.closest('[data-close]')) {this.dialog.close();return;}
      if(event.target===this.dialog) {const r=this.dialog.getBoundingClientRect();if(event.clientX<r.left || event.clientX>r.right || event.clientY<r.top || event.clientY>r.bottom) this.dialog.close();return;}
      const details=event.target.closest('[data-details]');if(!details) return;
      const fragment=details.closest('.oa-card').querySelector('template').content.cloneNode(true);
      const source=fragment.querySelector('.oa-description-source');
      const safe=clean(new DOMParser().parseFromString(source.textContent,'text/html').body);
      if(safe.textContent.trim() || safe.querySelector?.('img')) {source.replaceChildren(safe);fragment.querySelector('.oa-fallback').remove();} else source.remove();
      this.dialog.querySelector('[data-detail-content]').replaceChildren(fragment);
      this.opener=details;this.oldOverflow=document.body.style.overflow;document.body.style.overflow='hidden';this.dialog.showModal();
      const gallery=this.dialog.querySelector('.oa-gallery');if(gallery) gallery.onscroll=()=>this.galleryEdges();this.galleryEdges();
    }
  }
  customElements.define('ola-product-addons',ProductAddons);
  ProductAddons.prototype.olaDraftBatchVersion='v16-1';
})();
